import { render, staticRenderFns } from "./PackagesOverlay.vue?vue&type=template&id=0de189ea"
import script from "./PackagesOverlay.vue?vue&type=script&lang=js"
export * from "./PackagesOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports